import { getCookie } from 'src/utils/getCookie'

export function getTiktokParams() {
  const ttp = getCookie('_ttp')

  return {
    ttp,
  }
}
